<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">
    {{ data.title }} Confirmation!
  </h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onCancel()"
    title="Close"
  ></i>
</div>
<div class="modal-body  text-grey">
  <p>
    {{ data?.message }} {{ data?.actionText }} :
    <span class="text-danger">"{{ checkMultipleJobs ? 'Selected' : data?.jobName }}"</span> ?
  </p>
  <mat-checkbox *ngIf="this.data.actionValue == 11" [(ngModel)]="deleteChecked"
    >Do you want to delete data from workstore/syncstore ?</mat-checkbox
  >
  <mat-checkbox *ngIf="this.data.actionValue == -1" [(ngModel)]="skipCloud"
    >Skip cloud deletion</mat-checkbox
  >
  <mat-checkbox *ngIf="this.data.actionValue == 11" [(ngModel)]="deleteWorkstoreData"
    >Delete workstore job data</mat-checkbox
  >
  <mat-checkbox *ngIf="this.data.actionValue == 11" [(ngModel)]="deleteSyncstoreData"
    >Delete syncstore job data</mat-checkbox
  >
  <p *ngIf="this.data.actionValue == 24" style="color: red">
    This will cancel the job and job data can get affected.
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
    {{ data.noBtnText }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    cdkFocusInitial
  >
    {{ data.yesBtnText }}
  </button>
</div>
